/** US display format used across registration and booking (e.g. (555) 123-4567). */
export const US_DISPLAY_PHONE_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$/;

export function isMaskedPhoneNumber(value: string | null | undefined): boolean {
  if (value == null) return false;
  return /[*•]/.test(String(value));
}

/** Keep last 4 digits; mask leading digits. 10-digit US numbers become (***) ***-1234. */
export function maskPhoneNumber(value: string | null | undefined): string {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  if (isMaskedPhoneNumber(raw)) return raw;

  const digits = raw.replace(/\D/g, '');
  if (digits.length === 0) return raw;

  const last4 = digits.slice(-4);
  if (digits.length === 10) return `(***) ***-${last4}`;
  if (digits.length === 11 && digits[0] === '1') return `+1 (***) ***-${last4}`;

  return `${'*'.repeat(Math.max(0, digits.length - 4))}${last4}`;
}

export function displayCustomerPhone(
  value: string | null | undefined,
  canViewFull: boolean
): string {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  if (isMaskedPhoneNumber(raw) || !canViewFull) {
    return maskPhoneNumber(raw);
  }
  return formatPhoneNumber(raw);
}

export function formatPhoneNumber(value: string): string {
  if (isMaskedPhoneNumber(value)) return value;
  const digits = value.replace(/\D/g, '');
  const trimmed = digits.slice(0, 10);
  if (trimmed.length === 0) return '';
  if (trimmed.length <= 3) return `(${trimmed}`;
  if (trimmed.length <= 6) return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
  return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
}

export function userHasPhoneRecord(user: {
  phone?: string | null;
  phoneNumber?: string | null;
  phone_number?: string | null;
} | null | undefined): boolean {
  if (!user || typeof user !== 'object') return false;
  const raw = user.phoneNumber ?? user.phone ?? user.phone_number;
  if (raw == null) return false;
  return String(raw).trim().length > 0;
}
